import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {listItem, navigation, listContainer } from './Navigation.module.scss';
import SectionTitle from './SectionTitle/SectionTitle';
import useScrollObserver from './hooks/useScrollObserver';
import { testAttributes } from '../Constants';

export default function Navigation({ data }) 
{
    const [activeId, setActiveId] = useState('');
    useScrollObserver(setActiveId);

    const renderTitles = () => 
        data.map((item, index) => 
            (
                <li
                    className={listItem}
                    key={item.id}
                    itemProp="itemListElement"
                    itemType="https://schema.org/ListItem"
                    data-testid={`${testAttributes.TABLE_OF_CONTENT_LIST_ITEM}-${index}`}
                >
                    <SectionTitle
                        title={item.label}
                        href={item.href}
                        active={activeId === item.id}
                    />
                    <meta itemProp="position" content={index + 1} />
                </li>
            ));

    return (
        <nav
            aria-label="table-of-content"
            itemScope
            itemType="https://schema.org/SiteNavigationElement"
            data-testid={testAttributes.TABLE_OF_CONTENT_NAVIGATION}
            className={navigation}
        >
            <ul
                className={listContainer}
                itemScope
                itemType="https://schema.org/ItemList"
                itemProp="itemListOrder"
                href="https://schema.org/ItemListOrderDescending"
                data-testid={testAttributes.TABLE_OF_CONTENT_LIST}
            >
                <meta itemProp="numberOfItems" content={`${data.length}`} />
                {renderTitles()}
            </ul>
        </nav>
    );
}

Navigation.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            href: PropTypes.string,
        })
    ).isRequired,   
};
